var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"btn",staticClass:"c-item bcx-borders",class:{'c-active':_vm.active},on:{"click":_setup.click}},[_c('div',[_c('span',{staticClass:"c-name"},[_vm._v(" "+_vm._s(_vm.$t("notifications." + _vm.item.notificationType))+" ")]),_c('span',{staticClass:"c-count"},[_vm._v(" "+_vm._s(_vm.item.count)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }